module.exports = __webpack_public_path__ + "static/media/icon-languageEvaluation.96e1b2a8.svg";